import curry from 'ramda/src/curry'
import pipe from 'ramda/src/pipe'
import defaultTo from 'ramda/src/defaultTo'
import prop from 'ramda/src/prop'
import path from 'ramda/src/path'

// query-string 6 pulled decode-uri-component 0.2 (GHSA-qr28-fpjm-wq7f,
// GHSA-vcc3-ghjq-m6fr); URLSearchParams covers the flat key=value parse here.
const parse = search => Object.fromEntries(new URLSearchParams(search))

export const getRouterLocation = path(['router', 'location'])

export const getRouterLocationPathname = pipe(
  getRouterLocation,
  prop('pathname'),
)

export const getRouterLocationSearch = pipe(
  getRouterLocation,
  prop('search'),
)

export const getRouterLocationQuery = pipe(
  getRouterLocationSearch,
  defaultTo(''),
  parse,
)

export const getRouterLocationQueryKey = curry(({ key }, state) => {
  return (getRouterLocationQuery(state) || {})[key]
})
